import { Navigate, Route } from "react-router-dom";
import { ListInventory } from "../components";

const inventoryRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"list:index"} />,
    <Route path="list" element={<ListInventory />} key={"list"} />,
];
export default inventoryRoutes;
